module.exports = __webpack_public_path__ + "static/media/Motor6.533d3c12.png";